import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import { AppModule } from '@modules/core/plugins/AppModule';
import {
  ADMIN_WEBHOOKS_HISTORY_ROUTE_NAME,
  AFFILIATE_WEBHOOKS_HISTORY_ROUTE_NAME,
} from '@modules/webhooks-history/constants';
import {
  ADMIN_WEBHOOKS_HISTORY_DETAILS_ROUTE_NAME,
  AFFILIATE_WEBHOOKS_HISTORY_DETAILS_ROUTE_NAME,
  TRANSLATION_GROUP_ADMIN_WEBHOOKS_DETAILS,
  TRANSLATION_GROUP_AFFILIATES_WEBHOOKS_DETAILS,
} from '@modules/webhooks-history/submodules/history-details/constants';
import {
  getTranslationAdminWebhooksHistoryDetailsKeys,
  getTranslationAffiliatesWebhooksHistoryDetailsKeys,
} from '@modules/webhooks-history/submodules/history-details/translations';

export class WebhooksHistoryDetailsModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_WEBHOOKS_HISTORY_ROUTE_NAME, {
      name: ADMIN_WEBHOOKS_HISTORY_DETAILS_ROUTE_NAME,
      path: 'details/:id',
      component: () => import('@modules/webhooks-history/submodules/history-details/pages/WebhooksHistoryDetailsPage/WebhooksHistoryDetailsPage.vue'),
    });

    router.addChildRoute(AFFILIATE_WEBHOOKS_HISTORY_ROUTE_NAME, {
      name: AFFILIATE_WEBHOOKS_HISTORY_DETAILS_ROUTE_NAME,
      path: 'details/:id',
      component: () => import('@modules/webhooks-history/submodules/history-details/pages/WebhooksHistoryDetailsPage/WebhooksHistoryDetailsPage.vue'),
    });
  }

  addMenu(): void { }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_ADMIN_WEBHOOKS_DETAILS, getTranslationAdminWebhooksHistoryDetailsKeys);
    mapper.addTranslationsMap(TRANSLATION_GROUP_AFFILIATES_WEBHOOKS_DETAILS, getTranslationAffiliatesWebhooksHistoryDetailsKeys);
  }
}
